export const GET_CAREER_SLIDE_ITEMS = 'GET_CAREER_SLIDE_ITEMS';
export const GET_CAREER_SLIDE_ITEM_BY_ID = 'GET_CAREER_SLIDE_ITEM_BY_ID';
export const UPDATE_CAREER_SLIDE_ITEM = 'UPDATE_CAREER_SLIDE_ITEM';
export const DELETE_CAREER_SLIDE_ITEM = 'DELETE_CAREER_SLIDE_ITEM';
export const CREATE_CAREER_SLIDE_ITEM = 'CREATE_CAREER_SLIDE_ITEM';
